import React from 'react';

import "./pages.css"
import { Row, Col ,Input,Button} from 'antd';
import {PhoneOutlined} from '@ant-design/icons';
import { Link } from "react-router-dom";

import CryptoJS from 'crypto-js';
import cookie from 'react-cookies';



class Login extends React.Component {
    constructor(props) {
        //父组件传入参数
        super(props);    
        //当前组件状态
        this.state = {    
			login:false,
			phoneNumber:"",
			code:"",
			codeFlag:false,
			
			tips:{
				show:false,
				type:"",
				text:"",
			},
        }
    };
    
    componentDidMount(){

    }


    changePhone = (e) =>{
		this.setState({phoneNumber : e.target.value})
	}
	
	changeCode = (e) =>{
		this.setState({code : e.target.value})
	}
	
	btnClickCode=()=>{
		// console.log(this.state.phoneNumber)
		// if((/^1[3456789]\d{9}$/.test(this.state.phoneNumber))){ 
		if((/^1(?:3\d{3}|5[^4\D]\d{2}|8\d{3}|7(?:[35-8]\d{2}|4(?:0\d|1[0-2]|9\d))|9[0135-9]\d{2}|66\d{2})\d{6}$/.test(this.state.phoneNumber))){ 
			this.setState({
				codeFlag:true,
				tips:{show:true,type:"tips-success",text:"验证码发送中..."}
			})
			this.requestCode();
		}else{
			this.setState({
				tips:{show:true,type:"tips-error",text:"手机号格式不正确！"}
			})
		}
	}
	
	requestCode=()=>{
		
		let formdata = new FormData();
		formdata.append("strmobile",this.state.phoneNumber); 
		formdata.append("stropenid",''); 
		formdata.append("wechartflag",0); 
		
		let url = "https://gateway1.moxidata.cn/guest/applogin/";
		let options = {
			method: "POST",
			body:formdata,
		}        
			
		//发起fetch
		fetch(url, options).then(
			(response) => {
				// console.log("response",response);
				return response.json()
			}
		).then(    //若通信完成，从response中获取数据
			(data) => {
				// console.log("fetch data", data);
				this.setState({
					codeFlag:true,
					tips:{show:true,type:"tips-success",text:"验证码已发送！"}
				})
			}
		).catch(    //若出错，打印error
			(error) => {
				console.log(error)
				this.setState({
					codeFlag:false,
					tips:{show:true,type:"tips-error",text:"验证码发送失败，请检查网络！"}
				})
			}
		)
	}
	
	btnClickSubmit=()=>{
		

		// if(!this.state.codeFlag){
		// 	this.setState({tips:{show:true,type:"tips-error",text:"请先获取验证码！"}})
		// }else{
		// 	if(this.state.code.length==6){
		// 		this.setState({tips:{show:true,type:"tips-success",text:"登录中..."}})
		// 		this.requestLogin();
		// 	}else{
		// 		this.setState({tips:{show:true,type:"tips-error",text:"验证码格式不正确！"}})
		// 	}
		// }
		

		if(this.state.code.length === 6){
			this.setState({tips:{show:true,type:"tips-success",text:"登录中..."}})
			this.requestLogin();
		}else{
			this.setState({tips:{show:true,type:"tips-error",text:"验证码格式不正确！"}})
		}
	}
	
	requestLogin=()=>{  
        let that = this;
		
		let formdata = new FormData();
		formdata.append("strmobile",this.state.phoneNumber); 
		formdata.append("strtoken",this.state.code); 
		
		let url = "https://gateway1.moxidata.cn/guest/userlogin/";
		let options = {
			method: "POST",
			body:formdata,
		}    

		//发起fetch
		fetch(url, options).then(
			(response) => {return response.json()}
		).then((data) => {
				// console.log("fetch login data", data);
				// 解密数据
				let plaintext = this.decrypt(data);
				console.log("login data", plaintext);
				if(plaintext.error === 1){
					that.loginSuccess(plaintext)
					this.setState({codeFlag:true,tips:{show:true,type:"tips-success",text:"登陆成功！"}})
				}else if(plaintext.result ==="用户不存在"){
                    // console.log("用户不存在，正在发起注册")
					// this.setState({codeFlag:false,tips:{show:true,type:"tips-error",text:"用户不存在，正在发起注册"}})
                    this.requestRegister()
                }
                else{
					this.setState({codeFlag:false,tips:{show:true,type:"tips-error",text:plaintext.result}})
				}
			}
		).catch(    //若出错，打印error
			(error) => {
				console.log(error)
				this.setState({codeFlag:false,tips:{show:true,type:"tips-error",text:"登录失败，请检查验证码！"}})
			}
		)
	}

    // 发起注册
    requestRegister = () => {

        let formdata = new FormData();

        formdata.append('method', "registerwebsite")
        formdata.append('strmobile', this.state.phoneNumber)
        formdata.append('strtoken', this.state.code)
        formdata.append('codeflag', 0)
        formdata.append('inventcode', "")

        let url = "https://gateway1.moxidata.cn/guest/userpro/";
        let options = {
            method: "POST",
            body: formdata,
        }

        //发起fetch
        fetch(url, options).then(
            (response) => {
                // console.log("response",response);
                return response.json()
            }
        ).then(    //若通信完成，从response中获取数据
            (data) => {
                // console.log("register data", data);
                let plaintext = this.decrypt(data);
                console.log("register:", plaintext)
                if(plaintext.error === 1){
                    this.requestLogin()
                }
            }
        )
    }
	
	loginSuccess(plaintext){
		let inFifteenMinutes = new Date(new Date().getTime() + 24 * 3600 * 1000);
		
		// 基本都有转到app.moxidata.cn，不在需要兼容www.moxidata.cn
		// cookie.save('jwt_v2', plaintext.jwt ,{ expires: inFifteenMinutes,path:"/",domain:".moxidata.cn" });
		// cookie.save('UserUid_v2', plaintext.useruid ,{ expires: inFifteenMinutes,path:"/",domain:".moxidata.cn"});
		// cookie.save('modelid_v2', plaintext.modelid ,{ expires: inFifteenMinutes,path:"/",domain:".moxidata.cn"});
		// cookie.save('phoneNumber_v2', plaintext.mobilenumber ,{ expires: inFifteenMinutes,path:"/",domain:".moxidata.cn"});
		// cookie.save('jwt', plaintext.oldjwt ,{ expires: inFifteenMinutes,path:"/",domain:".moxidata.cn"});

		
		cookie.save('jwt_v2', plaintext.jwt ,{ expires: inFifteenMinutes,path:"/" });
		cookie.save('UserUid_v2', plaintext.useruid ,{ expires: inFifteenMinutes,path:"/"});
		cookie.save('modelid_v2', plaintext.modelid ,{ expires: inFifteenMinutes,path:"/"});
		cookie.save('phoneNumber_v2', plaintext.mobilenumber ,{ expires: inFifteenMinutes,path:"/"});
		cookie.save('jwt', plaintext.oldjwt ,{ expires: inFifteenMinutes,path:"/"});

		this.setState({login:true})
		window.history.go(-1)
		window.location=document.referrer;

		// this.props.closeLogin();
	}

        	
	decrypt=(data)=>{
		// 常量：iv列表
		let ary_ivs = ['tudfstevaustweli', 'delibejishanheqi', 'enxdyqrsoqwinofs', 'mpiksotudmghbtiw'];
		
		// 获取data
		let Base64CBC = data.codestring;
		
		// console.log("Base64CBC",Base64CBC)
		let ivnumber=data.pagnumber
		let key = data.pagnameid		
		
		// 解码数据
		let iv = CryptoJS.enc.Utf8.parse(ary_ivs[ivnumber]);
		key = CryptoJS.enc.Utf8.parse(key);

		// 解密data
		var decrypted =  CryptoJS.AES.decrypt(Base64CBC, key, { iv: iv, mode: CryptoJS.mode.CBC});
		let decrypted2 = decrypted.toString(CryptoJS.enc.Utf8);
		let obj_records = JSON.parse(decrypted2);
		
		return obj_records
	}
	
    
	
    render(){
        return(
            <div className="login-page">
                <Row className="login-fun-body">
					{/* <img className='login-close-img' src='image/close.png' onClick={this.props.closeLogin}/> */}
                    <Col className='login-body-left'>
                        <div className='login-slogan'>
                            愿和<span style={{fontSize:"37px"}}>森林</span>一样<br/>
                            由苗成树、由树成林<br/>
                            共建有 “营养” 的<br/>
                            产业生态圈<br/>
                        </div>
                    </Col>
                    <Col className='login-body-right'>
                        
                        <Row className="login-text" align="bottom" justify="start">用户登录</Row>
                    
                        <div className="login-input">
                            <Row className="login-input-phone">
                                <Input id="phone-input" placeholder="手机号" prefix={<PhoneOutlined />} onChange={this.changePhone} />
                            </Row>
                            <Row className="login-input-code" justify="space-between">
                                <Col><Input id="code-input" placeholder="验证码" size="large" onChange={this.changeCode}/></Col>
                                <Col><Button id="code-btn" onClick={this.btnClickCode} disabled={this.state.codeFlag}>发送验证码</Button></Col>
                            </Row>
                            {this.state.tips.show && <Row className={`${this.state.tips.type}`}>{this.state.tips.text}</Row>}
                        </div>
                        
                        <Row className="login-button-div" justify="center"><Button block onClick={this.btnClickSubmit} type="primary" size="large" className='login-button'>登录 / 注册</Button></Row>
                        <Row className='login-agreement'>
                            <span>登录或完成注册即代表您同意<Link to="/forest/agreement"> 用户协议 </Link>或<Link to="/forest/agreement"> 隐私政策 </Link>。</span>
                            未注册过魔席网的手机号，我们将自动帮您注册账号
                        </Row>

                    </Col>

                    
                    
                </Row>
            </div>
        );
    }
        
}

export default Login;

